import { render, staticRenderFns } from "./BibleVideoPanel.vue?vue&type=template&id=530599ea&scoped=true"
import script from "./BibleVideoPanel.vue?vue&type=script&lang=js"
export * from "./BibleVideoPanel.vue?vue&type=script&lang=js"
import style0 from "./BibleVideoPanel.vue?vue&type=style&index=0&id=530599ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530599ea",
  null
  
)

export default component.exports